import api from "./api";

export const register =
    async (
        payload
    ) => {
        try {
            const response =
                await api.post(
                    "/auth/register",
                    {
                        ...payload,
            }
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.detail ||
                    response.data
                        ?.message ||
                    "Registration failed",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.response
                        ?.data
                        ?.message ||
                    "Registration failed",
            };
        }
    };


export const login =
    async (
        username,
        password
    ) => {
        try {
            const formData =
                new URLSearchParams();

            formData.append(
                "username",
                username
            );

            formData.append(
                "password",
                password
            );

            const response =
                await api.post(
                    "/auth/driver-partner/login",
                    formData,
                    {
                        headers:
                            {
                                "Content-Type":
                                    "application/x-www-form-urlencoded",
                            },
                        withCredentials:
                            true,
                    }
                );

            if (
                response.status ===
                    200 &&
                response.data
                    .access_token
            ) {
                localStorage.setItem(
                    "access_token",
                    response
                        .data
                        .access_token
                );

                const csrfToken =
                    response
                        .headers[
                        "x-csrf-token"
                    ] ||
                    response
                        .headers[
                        "X-CSRF-Token"
                    ];

                if (
                    csrfToken
                ) {
                    document.cookie = `csrf_token=${csrfToken}; path=/; secure; samesite=strict`;
                }

                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                error:
                    "Unexpected response from server",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    "Login failed",
            };
        }
    };


export const verifyOtp =
    async ({
        user_id,
        otp,
    }) => {
        try {
            const response =
                await api.post(
                    "/auth/verify-otp",
                    {
                        user_id,
                        otp,
                    }
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.detail ||
                    "OTP verification failed",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    "OTP verification failed",
            };
        }
    };


export const passwordReset =
    async (
        email
    ) => {
        try {
            const response =
                await api.post(
                    "/auth/password-reset",
                    {
                        email,
                    }
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.detail ||
                    response.data
                        ?.message ||
                    "Password reset failed",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    "Password reset failed",
            };
        }
    };


export const confirmPasswordReset =
    async (
        payload
    ) => {
        try {
            const response =
                await api.post(
                    "/auth/password-reset/confirm",
                    payload
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.detail ||
                    response.data
                        ?.message ||
                    "Password reset confirmation failed",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    "Password reset confirmation failed",
            };
        }
    };

export const updateUserProfile =
    async (
        profileData
    ) => {
        try {
            const response =
                await api.put(
                    "/auth/profile/update",
                    {
                        first_name:
                            profileData.first_name,
                        middle_name:
                            profileData.middle_name,
                        last_name:
                            profileData.last_name,
                        postal_address:
                            profileData.postal_address,
                        physical_address:
                            profileData.physical_address,
                        district:
                            profileData.district,
                        village:
                            profileData.village,
                        id_or_passport_number:
                            profileData.id_or_passport_number,
                    }
                );

            if (
                response.status ===
                    200 ||
                response.status ===
                    204
            ) {
                return {
                    success: true,
                    data:
                        response.data,
                };
            }

            return {
                success: false,
                error:
                    "Failed to update profile",
            };
        } catch (
            error
        ) {
            console.error(
                "Profile Update Error:",
                error
                    .response
                    ?.data ||
                    error.message
            );

            return {
                success: false,
                error:
                    error
                        .response
                        ?.data
                        ?.detail ||
                    "Could not update profile",
            };
        }
    };

export const changePassword =
    async (
        currentPassword,
        newPassword
    ) => {
        try {
            const response =
                await api.put(
                    `/auth/change-password?current_password=${encodeURIComponent(
                        currentPassword
                    )}&new_password=${encodeURIComponent(
                        newPassword
                    )}`
                );

            if (
                response.status === 200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data:
                        response.data,
                };
            }

            return {
                success: false,
                error:
                    "Failed to change password",
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message ||
                    "Password change failed",
            };
        }
    };

// Request Account Deletion
export const requestAccountDeletion = async () => {
    try {
        const response = await api.post(
            "auth/privacy/request-deletion"
        );

        if (
            response.status === 200 ||
            response.status === 202
        ) {
            return {
                success: true,
                data: response.data,
            };
        }

        return {
            success: false,
            error:
                "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Request Deletion Error:",
            error.response?.data ||
            error.message
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                "Request failed",
        };
    }
};